import {baseURL} from '@/infrastructure/Configuration'
import axios from "axios";
import {mapActions, mapGetters} from "vuex";

export default {
    computed: {
        ...mapGetters(["getToken", "getTypeAuth"]),
    },
    methods: {
        ...mapActions(["setSessionTime"]),
        httpSession(){
            this.setSessionTime()
            return axios.create({
                baseURL: baseURL,
                withCredentials: true,  // Envía cookies en cada solicitud
                headers: {
                    "Content-type": "application/json",
                    Authorization: `${this.getTypeAuth} ${this.getToken}`
                },
                validateStatus: (status) => status === 200
            });
        },
        httpLogin(){
            return axios.create({
                baseURL: baseURL,
                validateStatus: (status) => status === 200
            });
        }
    }
};
